import Image from 'next/image'
import React from 'react'

interface MemberCardProps {
    image: string
    name: string
    position: string
}

const MemberCard = ({ image, name, position }: MemberCardProps) => {
    return (
        <div className='flex flex-col items-center p-4 bg-gray-100 rounded-lg w-full max-w-[228px] mb-4'>
            <div className='flex justify-center w-[180px] h-[180px]'>
                <Image
                    src={image}
                    alt={name}
                    width={180}
                    height={180}
                    className="w-[180px] h-[180px] object-cover object-[center_30%] rounded-full"
                />
            </div>
            <div className='text-center uppercase mt-4 p-2 border border-black w-full'>
                <h2 className="font-bold text-sm">{name}</h2>
                <p className="text-xs">{position}</p>
            </div>
        </div>
    )
}

export default MemberCard
